import s1 from '@/assets/img/svg/services/services-1.svg'
import s2 from '@/assets/img/svg/services/services-2.svg'
import s3 from '@/assets/img/svg/services/services-3.svg'
import s4 from '@/assets/img/svg/services/services-4.svg'
import sl1 from '@/assets/img/svg/services/services-light-1.svg'
import sl2 from '@/assets/img/svg/services/services-light-2.svg'
import sl3 from '@/assets/img/svg/services/services-light-3.svg'
import sl4 from '@/assets/img/svg/services/services-light-4.svg'

import blog1 from '@/assets/img/shortcode/blog/blog-05.jpg'
import blog2 from '@/assets/img/shortcode/blog/blog-06.jpg'
import blog3 from '@/assets/img/home-v3/blog.jpg'

export const servicesData = [
    {
        id:1,
        image:s1,
        image2:sl1,
        title:'Luxury Sofa Set',
        product:'26 Products',
        desc:'Elevate your living space with unparalleled comfort and style. Discover the epitome of luxury with our exquisite sofa sets.'
    },
    {
        id:2,
        image:s2,
        image2:sl2,
        title:'Table & Chair',
        product:'40 Products',
        desc:'Elevate your living space with unparalleled comfort and style. Discover the epitome of luxury with our exquisite sofa sets.'
    },
    {
        id:3,
        image:s3,
        image2:sl3,
        title:'Vases & Lamp',
        product:'14 Products',
        desc:'Elevate your living space with unparalleled comfort and style. Discover the epitome of luxury with our exquisite sofa sets.'
    },
    {
        id:4,
        image:s4,
        image2:sl4,
        title:'Interior Collection',
        product:'32 Products',
        desc:'Elevate your living space with unparalleled comfort and style. Discover the epitome of luxury with our exquisite sofa sets.'
    },
]

export const blogData = [
    {
        image:blog1,
        date:'13th March 2025',
        tag:'Interior',
        title:'Transform Your Space: Top Furniture Trends for Modern Homes'
    },
    {
        image:blog2,
        date:'5th May 2025',
        tag:'Bedroom',
        title:'The Art of Interior Design: Choosing the Perfect Furniture Online'
    },
    {
        image:blog3,
        date:'19th June 2025',
        tag:'Interior',
        title:'5 Must-Have Features for an Outstanding Furniture'
    },
]